import Signal from 'signals';
export default class SingletonClass {
    static _instance = new SingletonClass()
    constructor() {
        SingletonClass._instance = this
        this.enter = new Signal.Signal();
        this.esc = new Signal.Signal();
        this.a = new Signal.Signal();
        this.b = new Signal.Signal();
        this.c = new Signal.Signal();
        this.d = new Signal.Signal();
        this.e = new Signal.Signal();
        this.f = new Signal.Signal();
        this.g = new Signal.Signal();
        this.h = new Signal.Signal();
        this.i = new Signal.Signal();
        this.j = new Signal.Signal();
        this.k = new Signal.Signal();
        this.l = new Signal.Signal();
        this.m = new Signal.Signal();
        this.n = new Signal.Signal();
        this.o = new Signal.Signal();
        this.p = new Signal.Signal();
        this.q = new Signal.Signal();
        this.r = new Signal.Signal();
        this.s = new Signal.Signal();
        this.t = new Signal.Signal();
        this.u = new Signal.Signal();
        this.v = new Signal.Signal();
        this.w = new Signal.Signal();
        this.x = new Signal.Signal();
        this.y = new Signal.Signal();
        this.z = new Signal.Signal();
        this.up = new Signal.Signal();
        this.down = new Signal.Signal();
        this.left = new Signal.Signal();
        this.right = new Signal.Signal();
        this.n1 = new Signal.Signal();
        this.n2 = new Signal.Signal();
        this.n3 = new Signal.Signal();
        this.n4 = new Signal.Signal();
        this.n5 = new Signal.Signal();
        this.n6 = new Signal.Signal();
        this.n7 = new Signal.Signal();
        this.n8 = new Signal.Signal();
        this.n9 = new Signal.Signal();
        this.n0 = new Signal.Signal();
        this.space = new Signal.Signal();
        this.n0=new Signal.Signal();
        this.home=new Signal.Signal();
        this.pgup=new Signal.Signal();
        this.pgdn=new Signal.Signal();
        this.onKeyPress = this.onKeyPress.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        document.onkeypress = this.onKeyPress;
        document.onkeydown = this.onKeyDown;
        this.fullScreen = false;
        this.fullScreenElement = null;
    }
    GoInFullscreen(el) {
        if(el.requestFullscreen){
            el.requestFullscreen();
        }else if(el.mozRequestFullScreen){
            el.mozRequestFullScreen();
        }else if(el.webkitRequestFullscreen){
            el.webkitRequestFullscreen();
        }else if(el.msRequestFullscreen){
            el.msRequestFullscreen();
        }else{
            console.log("else");
        }
    }
    GoOutFullscreen() {
        if(document.exitFullscreen){
            document.exitFullscreen();
        }else if(document.mozCancelFullScreen){
            document.mozCancelFullScreen();
        }else if(document.webkitExitFullscreen){
            document.webkitExitFullscreen();
        }else if(document.msExitFullscreen){
            document.msExitFullscreen();
        }else{
            console.log("else");
        }
    }
    updateF(el){
        this.fullScreenElement = el;
    }
    onKeyDown(e){
        // console.log(e.keyCode);
        switch(e.keyCode){
            case 27:
                this.esc.dispatch();
                break;
            case 37:
                this.left.dispatch();
                break;
            case 38:
                this.up.dispatch();
                break;
            case 39:
                this.right.dispatch();
                break;
            case 40:
                this.down.dispatch();
                break;
            case 36://home
                this.home.dispatch();
                break;
            case 33://pgup
                this.pgup.dispatch();
                break;
            case 34://pgdn
                this.pgdn.dispatch();
                break;
            default:
                break;
        }
    }
    onKeyPress(e){
        // console.log('press',e.keyCode)
        switch(e.keyCode){
            case 65:
            case 97:
                this.a.dispatch();
                break;
            case 66:
            case 98:
                this.b.dispatch();
                break;
            case 67:
            case 99:
                this.c.dispatch();
                break;
            case 68:
            case 100:
                this.d.dispatch();
                break;
            case 69:
            case 101:
                this.e.dispatch();
                break;
            case 70:
            case 102:
                this.f.dispatch();
                break;
            case 71:
            case 103:
                this.g.dispatch();
                break;
            case 72:
            case 104:
                this.h.dispatch();
                break;
            case 73:
            case 105:
                this.i.dispatch();
                break;
            case 74:
            case 106:
                this.j.dispatch();
                break;
            case 75:
            case 107:
                this.k.dispatch();
                break;
            case 76:
            case 108:
                this.l.dispatch();
                break;
            case 77:
            case 109:
                this.m.dispatch();
                break;
            case 78:
            case 110:
                this.n.dispatch();
                break;
            case 79:
            case 111:
                this.o.dispatch();
                break;
            case 80:
            case 112:
                this.p.dispatch();
                break;
            case 81:
            case 113:
                this.q.dispatch();
                break;
            case 82:
            case 114:
                this.r.dispatch();
                break;
            case 83:
            case 115:
                this.s.dispatch();
                break;
            case 84:
            case 116:
                this.t.dispatch();
                break;
            case 85:
            case 117:
                this.u.dispatch();
                break;
            case 86:
            case 118:
                this.v.dispatch();
                break;
            case 87:
            case 119:
                this.w.dispatch();
                break;
            case 88:
            case 120:
                this.x.dispatch();
                break;
            case 89:
            case 121:
                this.y.dispatch();
                break;
            case 90:
            case 122:
                this.z.dispatch();
                break;
                // num
            case 48:
                this.n0.dispatch();
                break;
            case 49:
                this.n1.dispatch();
                break;
            case 50:
                this.n2.dispatch();
                break;
            case 51:
                this.n3.dispatch();
                break;
            case 52:
                this.n4.dispatch();
                break;
            case 53:
                this.n5.dispatch();
                break;
            case 54:
                this.n6.dispatch();
                break;
            case 55:
                this.n7.dispatch();
                break;
            case 56:
                this.n8.dispatch();
                break;
            case 57:
                this.n9.dispatch();
                break;
            case 32:
                this.space.dispatch();
                break;
            case 13:
                this.enter.dispatch();
                break;
            default:
                break;
        }
    }
    add(_signal, _callback){
        this[_signal].add(_callback);
    }
    remove(_callback,_signal){
        this[_signal].remove(_callback);
    }
    static getInstance() {
        return SingletonClass._instance;
    }

}